module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"da":{"header-wishlist-button":{"wishlist":"Ønsker"}},"de":{"version":1,"header-wishlist-button":{"wishlist":"Merkzettel"}},"en":{"header-wishlist-button":{"wishlist":"wishlist"}},"fr":{"header-wishlist-button":{"wishlist":"Favoris"}},"nl":{"header-wishlist-button":{"wishlist":"Wensen"}},"pl":{"header-wishlist-button":{"wishlist":"Lista zakupów"}}}')
  delete Component.options._Ctor
}
